var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{class:{'input-box': true, 'highlight-no-value': !_vm.hasValue },attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onTextInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }